import Service from './service.js';

export class Termination extends Service {
    constructor(product) {
        super('#form-service-termination', 'termination');
        this.product = JSON.parse(product);
        this.reasons = document.querySelector('#termination-reason');
        this.deliveryEnd = document.querySelector('#termination-deliveryend');
        this.note = document.querySelector('#termination-note');
        
        this.noTerminationOfferButton = document.querySelector('.noTerminationOffer');
        this.hasTerminationOfferButton = document.querySelector('.hasTerminationOffer');
        
        this.reasonSubmit = document.querySelectorAll('.reasonSubmit');
        this.terminatePrintOnly = document.querySelector('.terminatePrintOnly');
        this.renew = document.querySelector('#termination-renew');
        
        this.offerId = 0;
        
        this.initService();
    };

    initService() {
        let takeOffer = document.querySelector('.take-offer');
        let takeBreak = document.querySelector('.take-break');
        
        if(takeOffer) {
            takeOffer.addEventListener('click', event => {
                event.preventDefault();
                let formUrl = event.currentTarget.getAttribute('href');
                let request = new Request('POST', formUrl + '/purchase');
                request.data = {
                    offerId : this.offerId,
                    reason : this.reasons.value,
                    pva : takeOffer.dataset.pva,
                    'Termination[note]' : this.note.value, 
                    'Termination[deliveryend]' : this.deliveryEnd.value,
                };
                
                request.call(function(data) {
                    if(data.status == 'ok') {
                        window.location = formUrl + '/success';
                    }
                });
            });
        }
        
        if(takeBreak) {
            this.breakStart = document.querySelector('#termination-breakstart');
            this.breakEnd = document.querySelector('#termination-breakend');
            
            takeBreak.addEventListener('click', event => {
                event.preventDefault();
                let formUrl = event.currentTarget.getAttribute('href');
                let request = new Request('POST', formUrl + '/break');
                request.data = {
                    'Termination[breakstart]' : this.breakStart.value,
                    'Termination[breakend]' : this.breakEnd.value,
                };
                
                request.call((data) => {
                    if(data.status == 'ok') {
                        window.location = formUrl + '/success';
                    } else {
                        this.error(data.error);
                    }
                });
            });
        }

        if (this.terminatePrintOnly) {
            this.terminatePrintOnly.addEventListener('click', event => {
                this.renew.value = 1;
            });
        }
        
        if(this.reasons) {
            this.reasons.addEventListener('change', event => {
               this.reasonChange();
            });
            this.reasonChange();
        }
    };
    
    toggleReasonSubmit(state) {
        if(this.reasonSubmit) {
            this.reasonSubmit.forEach(button => {
                button.disabled = state;
                if (state) {
                    button.classList.add('disabled');
                } else {
                    button.classList.remove('disabled');
                }
            });
        }
    };
    
    updateTerminationOffer() {
        this.toggleOffer(false);
        let offers = document.querySelectorAll('.terminationOffer');
        let combo = document.querySelectorAll('.combo');
        if(offers.length) {
            offers.forEach(offer => {
                let show = true;
                let shows = [];
                let data = offer.dataset;
                for(let i in data) {
                    if(i != 'id') {
                        let show = false;
                        let values = data[i].split(',');
                        for(let u in values) {
                            if(typeof this.product[i] === 'undefined' && values[u] == '-') {
                                show = true;
                            }
                            if(typeof this.product[i] !== 'undefined' && values[u] == this.product[i]) {
                                show = true;
                            }
                        }
                        shows.push(show);
                    }
                };
                for(let i in shows) {
                    if(!shows[i]) {
                        show = false;
                    }
                }
                
                if(show) {
                    this.toggleOffer(true);
                    offer.classList.remove('d-none');
                    this.offerId = offer.dataset.id;
                    return false;
                } else {
                    offer.classList.add('d-none');
                }
            });
        }
        
        if (combo.length) {
            this.toggleOffer(true);
        }
    };
    
    toggleOffer(show) {
        if(show) {
            this.noTerminationOfferButton.classList.add('d-none');
            this.noTerminationOfferButton.classList.remove('d-block', 'd-sm-inline-block');
            this.hasTerminationOfferButton.classList.remove('d-none');
            this.hasTerminationOfferButton.classList.add('d-block', 'd-sm-inline-block');
        } else {
            this.noTerminationOfferButton.classList.remove('d-none');
            this.noTerminationOfferButton.classList.add('d-block', 'd-sm-inline-block');
            this.hasTerminationOfferButton.classList.add('d-none');
            this.hasTerminationOfferButton.classList.remove('d-block', 'd-sm-inline-block');
        }
    };

    reasonChange() {
        this.product['reason'] = this.reasons.value;
        this.updateTerminationOffer();
        let buttonState = (this.reasons.value) ? false : true;
        this.toggleReasonSubmit(buttonState);
    }
};
